
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("86upE", function(module, exports) {
/* ContentByLabelMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $6T2gk = parcelRequire("6T2gk");





var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $lTGWQ = parcelRequire("lTGWQ");

const $8c10b7ed0d23895f$export$f238d9824f6c55bf = (macroParamsForQuery, maxResults)=>{
    const { cql: cql } = macroParamsForQuery;
    const shouldSkipQuery = !cql?.trim();
    const [loadMoreError, setLoadMoreError] = (0, $cozmU.useState)();
    const [isLoadingMore, setIsLoadingMore] = (0, $cozmU.useState)(false);
    const { data: data, error: error, loading: loading, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)((0, $6T2gk.default), {
        variables: {
            ...macroParamsForQuery,
            skipSearchTitle: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title'),
            skipContentTitle: !(0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title')
        },
        skip: shouldSkipQuery,
        fetchPolicy: 'cache-first',
        __callerPackage__: "content-by-label-macro"
    });
    const loadedCount = data?.search?.nodes?.length ?? 0;
    const remainingCount = Math.max(maxResults - loadedCount, 0);
    const pageInfo = data?.search?.pageInfo;
    const canLoadMore = !shouldSkipQuery && remainingCount > 0 && Boolean(pageInfo?.hasNextPage) && Boolean(pageInfo?.endCursor) && (0, $9wGTI.fg)('cc_rewrite_contentbylabel_paginate_results');
    const loadMore = (0, $cozmU.useCallback)(async ()=>{
        const endCursor = pageInfo?.endCursor;
        if (!canLoadMore || !endCursor || loading || isLoadingMore) return;
        setLoadMoreError(undefined);
        setIsLoadingMore(true);
        await fetchMore({
            variables: {
                after: endCursor,
                first: Math.min((0, $lTGWQ.BACKEND_MAX_RESULTS_PER_REQUEST), remainingCount)
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult?.search) return prev;
                return {
                    ...prev,
                    search: {
                        ...prev.search ?? {},
                        nodes: [
                            ...prev.search?.nodes ?? [],
                            ...fetchMoreResult.search.nodes ?? []
                        ],
                        pageInfo: fetchMoreResult.search.pageInfo
                    }
                };
            }
        }).catch((err)=>{
            setLoadMoreError(err instanceof Error ? err : new Error(String(err)));
        }).finally(()=>{
            setIsLoadingMore(false);
        });
    }, [
        canLoadMore,
        fetchMore,
        isLoadingMore,
        loading,
        pageInfo?.endCursor,
        remainingCount
    ]);
    return {
        data: data,
        error: error ?? null,
        loading: Boolean(loading),
        hasNextPage: canLoadMore,
        isLoadingMore: isLoadingMore,
        loadMore: canLoadMore ? loadMore : undefined,
        loadMoreError: loadMoreError
    };
};








var $d129bc68587a4873$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["Page"] = "page";
    ContentType["Blogpost"] = "blogpost";
    ContentType["LivePage"] = "live-page";
    ContentType["Whiteboard"] = "whiteboard";
    ContentType["Database"] = "database";
    ContentType["Embed"] = "embed";
    ContentType["Folder"] = "folder";
    ContentType["Slide"] = "slide";
    return ContentType;
}({});


function $3ee95ce1d66ab67e$export$b441af81100aa49a(type, subType) {
    if (type === 'blogpost') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Blogpost;
    if (type === 'liveDoc' || type === 'page' && subType === 'live') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).LivePage;
    if (type === 'whiteboard') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Whiteboard;
    if (type === 'database') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Database;
    if (type === 'embed') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Embed;
    if (type === 'folder') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Folder;
    if (type === 'slide') return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Slide;
    return (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Page;
}
function $3ee95ce1d66ab67e$var$extractLabels(content) {
    const labels = [];
    const rawLabels = content?.labels?.nodes;
    if (rawLabels) {
        for (const label of rawLabels)if (label != null) labels.push({
            name: label.name ?? ''
        });
    }
    return labels;
}
function $3ee95ce1d66ab67e$export$11c8697609bb0569(data) {
    if (!data?.search?.nodes) return undefined;
    const items = [];
    for (const node of data.search.nodes){
        if (node == null) continue;
        items.push({
            id: node.content?.id ?? '',
            title: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title') ? node.content?.title ?? '' : node.title ?? '',
            type: $3ee95ce1d66ab67e$export$b441af81100aa49a(node.content?.type, node.content?.subType),
            url: node.url ? `/wiki${node.url}` : '',
            space: {
                id: node.content?.space?.id ?? '',
                key: node.content?.space?.key ?? '',
                name: node.content?.space?.name ?? ''
            },
            excerpt: node.content?.macroExcerpt?.atlasDocFormat ?? '',
            mediaToken: node.content?.body?.atlas_doc_format?.mediaToken?.token ?? '',
            labels: $3ee95ce1d66ab67e$var$extractLabels(node.content)
        });
    }
    return {
        items: items
    };
}





const $af06f72efa10cc57$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    emptyTitle: {
        id: "content-by-label-macro.emptyTitle",
        defaultMessage: "Filter by label"
    },
    emptyContent: {
        id: "content-by-label-macro.emptyContent",
        defaultMessage: "There are no items with the selected labels at this time."
    },
    emptyContentInEditor: {
        id: "content-by-label-macro.emptyContentInEditor",
        defaultMessage: "There are no items with the selected labels at this time. Click the edit icon to configure labels."
    },
    error: {
        id: "content-by-label-macro.error",
        defaultMessage: "An error occurred while loading content by label."
    },
    loading: {
        id: "content-by-label-macro.loading",
        defaultMessage: "Retrieving content\u2026"
    },
    errorLabelsRequired: {
        id: "content-by-label-macro.errorLabelsRequired",
        defaultMessage: "'labels' parameter is required."
    },
    errorParseMax: {
        id: "content-by-label-macro.errorParseMax",
        defaultMessage: "Error parsing 'maxResults' parameter."
    },
    errorSearch: {
        id: "content-by-label-macro.errorSearch",
        defaultMessage: "Error running search."
    },
    errorInvalidInput: {
        id: "content-by-label-macro.errorInvalidInput",
        defaultMessage: "Invalid input."
    },
    excerptSeparator: {
        id: "content-by-label-macro.excerptSeparator",
        defaultMessage: "\u2014"
    },
    spaceLabel: {
        id: "content-by-label-macro.spaceLabel",
        defaultMessage: "({spaceName})"
    },
    loadMore: {
        id: "content-by-label-macro.loadMore",
        defaultMessage: "Load more..."
    }
});


/* ContentEntry.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $lBKFk = parcelRequire("lBKFk");


var $2hJf7 = parcelRequire("2hJf7");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $cSGyR = parcelRequire("cSGyR");


var $bDjVc = parcelRequire("bDjVc");


var $kWSTb = parcelRequire("kWSTb");


var $kLlYX = parcelRequire("kLlYX");


var $7vK9E = parcelRequire("7vK9E");





var $1l0kj = parcelRequire("1l0kj");



/* ContentExcerpt.tsx generated by @compiled/babel-plugin v3.0.2 */ 








const $cca4a13a0573e764$var$styles = {
    excerptOuter: "_1UtDYzZpcK _39xV02DC6J _4bt5LAIZbP",
    excerptInner: "_4rYULUAkOf"
};
const $cca4a13a0573e764$var$parseAdfDocument = (adf)=>{
    if (!adf) return null;
    try {
        return JSON.parse(adf);
    } catch  {
        return null;
    }
};
const $cca4a13a0573e764$export$c719936edb709f23 = (excerptType, excerpt)=>{
    if (excerptType === (0, $lTGWQ.ExcerptType).None) return false;
    const adfDocument = $cca4a13a0573e764$var$parseAdfDocument(excerpt);
    if (adfDocument && adfDocument.content && adfDocument.content.length > 0 && adfDocument.content.some((node)=>'content' in node && Array.isArray(node.content) && node.content.length > 0)) return adfDocument;
    return false;
};
const $cca4a13a0573e764$export$effe901625ca8e92 = function ContentExcerpt({ adfDocument: adfDocument, excerptType: excerptType, mediaToken: mediaToken, contentId: contentId, spaceKey: spaceKey, spaceId: spaceId, RendererWrapper: RendererWrapper }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cca4a13a0573e764$var$styles.excerptOuter,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cca4a13a0573e764$var$styles.excerptInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RendererWrapper, {
        adf: adfDocument.content,
        mediaToken: mediaToken,
        targetContentId: contentId,
        targetSpaceKey: excerptType === (0, $lTGWQ.ExcerptType).RichContent ? spaceKey : '',
        targetSpaceId: excerptType === (0, $lTGWQ.ExcerptType).RichContent ? spaceId ?? undefined : undefined
    })));
};


/* LabelList.tsx generated by @compiled/babel-plugin v3.0.2 */ 











const $d19b297071101ee6$var$styles = {
    labelChip: "_0bjKvDKxmn _2sNsIg7NXe _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065UFQfX _2Y7lL41Y8M _0KLXruDMqu",
    labelLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $d19b297071101ee6$export$835fcf23ab7bf88 = function LabelList({ labels: labels, spaceKey: spaceKey, limitLabelLinksToSpace: limitLabelLinksToSpace }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        shouldWrap: true,
        testId: "content-by-label-labels"
    }, labels.map((label)=>{
        const labelUrl = limitLabelLinksToSpace && spaceKey ? `/wiki/label/${spaceKey}/${label.name}` : `/wiki/label/${label.name}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            key: label.name,
            href: labelUrl,
            testId: `label-${label.name}`,
            xcss: $d19b297071101ee6$var$styles.labelLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d19b297071101ee6$var$styles.labelChip
        }, label.name));
    }));
};


const $bfbce6defdac332d$var$styles = {
    listItem: "_43nrzT2ADO",
    listItemFirst: "_43nrzTPgdg",
    details: "_0LQT5ENHnM",
    spaceInfo: "_1UtDYzKGUX",
    contentTypeIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    titleLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $bfbce6defdac332d$export$af895a2490aecfd5 = function ContentEntry({ item: item, showLabels: showLabels, showSpace: showSpace, excerptType: excerptType, limitLabelLinksToSpace: limitLabelLinksToSpace, isFirst: isFirst, RendererWrapper: RendererWrapper }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const excerptDocument = (0, $cca4a13a0573e764$export$c719936edb709f23)(excerptType, item.excerpt);
    const getContentTypeIcon = ()=>{
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Blogpost) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: ""
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).LivePage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))), {
            label: ""
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Whiteboard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
            label: "",
            testId: "content-type-glyph-whiteboard"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Database) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
            label: "",
            testId: "content-type-glyph-database"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Embed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))), {
            label: "",
            testId: "content-type-glyph-embed"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Folder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            testId: "content-type-glyph-folder"
        });
        if (item.type === (0, $d129bc68587a4873$export$e2e108cbe2e4f865).Slide) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))), {
            label: "",
            testId: "content-type-glyph-slide"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            label: ""
        });
    };
    const contentTypeIcon = getContentTypeIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: isFirst ? $bfbce6defdac332d$var$styles.listItemFirst : $bfbce6defdac332d$var$styles.listItem,
        testId: `content-entry-${item.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        testId: "content-by-label-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bfbce6defdac332d$var$styles.contentTypeIcon,
        testId: `content-type-icon-${item.type}`
    }, contentTypeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: item.url,
        xcss: $bfbce6defdac332d$var$styles.titleLink
    }, item.title), showSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $bfbce6defdac332d$var$styles.spaceInfo
    }, formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).spaceLabel, {
        spaceName: item.space.name
    })), excerptDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $bfbce6defdac332d$var$styles.spaceInfo
    }, formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).excerptSeparator))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bfbce6defdac332d$var$styles.details
    }, excerptDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cca4a13a0573e764$export$effe901625ca8e92), {
        adfDocument: excerptDocument,
        mediaToken: item.mediaToken,
        excerptType: excerptType,
        contentId: item.id,
        spaceKey: item.space.key,
        spaceId: item.space.id,
        RendererWrapper: RendererWrapper
    }), showLabels && item.labels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d19b297071101ee6$export$835fcf23ab7bf88), {
        labels: item.labels,
        spaceKey: item.space.key,
        limitLabelLinksToSpace: limitLabelLinksToSpace
    }))));
};


/* EmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 












const $629ac813f858bbca$var$styles = {
    container: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _4c065U8HPE _2Y7lL48HPE _4kiQYAIZbP",
    heading: "_2sNsIgmnOE _1UtDYzKGUX _1kk5Tku7m9",
    message: "_1UtDYzKGUX"
};
const $629ac813f858bbca$export$fddf379e22a74b00 = ({ title: title, showEditCTA: showEditCTA })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $629ac813f858bbca$var$styles.container,
        testId: "content-by-label-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $629ac813f858bbca$var$styles.heading,
        as: "h5"
    }, title || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).emptyTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $629ac813f858bbca$var$styles.message,
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showEditCTA ? (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).emptyContentInEditor : (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).emptyContent))));
};


/* LoadingState.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $lfoFx = parcelRequire("lfoFx");


const $cf8b8295edbb494d$var$styles = {
    container: "_4c065U8HPE _2Y7lL48HPE _4kiQYAIZbP"
};
const $cf8b8295edbb494d$export$62aa48085237e36f = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cf8b8295edbb494d$var$styles.container,
        testId: "content-by-label-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).loading)
    })));
};


const $cd3bdf4cbbb70502$var$styles = {
    list: "_3SamIH2ADO _0LQT5EPgdg _0aNu0LYbGa",
    invalidInputErrorDetail: "_3zvHkHdC7N"
};
const $cd3bdf4cbbb70502$var$BAD_REQUEST_EXCEPTION_ERROR_MESSAGE = 'BadRequestException';
const $cd3bdf4cbbb70502$var$isBadRequestExceptionError = (error)=>error.message.includes($cd3bdf4cbbb70502$var$BAD_REQUEST_EXCEPTION_ERROR_MESSAGE);
const $cd3bdf4cbbb70502$var$ContentByLabelMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams, RendererWrapper: RendererWrapper })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { cql: cql, max: max, maxParseError: maxParseError, title: title, showLabels: showLabels, showSpace: showSpace, excerptType: excerptType, limitLabelLinksToSpace: limitLabelLinksToSpace, macroParamsForQuery: macroParamsForQuery } = (0, $lTGWQ.useParsedMacroParams)(macroParams, macroDefaultProps?.spaceKey, contentId);
    const { data: queryData, error: error, loading: loading, hasNextPage: hasNextPage, isLoadingMore: isLoadingMore, loadMore: loadMore, loadMoreError: loadMoreError } = (0, $8c10b7ed0d23895f$export$f238d9824f6c55bf)(macroParamsForQuery, max);
    const processedData = (0, $3ee95ce1d66ab67e$export$11c8697609bb0569)(queryData);
    const items = processedData?.items;
    if (!cql) {
        const labelsRequiredError = new Error(formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorLabelsRequired));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: labelsRequiredError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: labelsRequiredError
        }));
    }
    if (maxParseError) {
        const parseMaxError = new Error(formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorParseMax));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: parseMaxError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: parseMaxError
        }));
    }
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf8b8295edbb494d$export$62aa48085237e36f), null);
    if (error) {
        if ($cd3bdf4cbbb70502$var$isBadRequestExceptionError(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                name: experienceName,
                contentId: contentId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                title: formatMessage((0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorInvalidInput),
                appearance: "error"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p",
                color: "color.text.subtle",
                xcss: $cd3bdf4cbbb70502$var$styles.invalidInputErrorDetail
            }, error.message)));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes,
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }));
    }
    if (!items || items.length === 0) {
        const isEditorPreview = macroDefaultProps?.mode === 'editor';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $629ac813f858bbca$export$fddf379e22a74b00), {
            title: title,
            showEditCTA: isEditorPreview
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "content-by-label-macro",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": ""
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        xcss: $cd3bdf4cbbb70502$var$styles.list
    }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfbce6defdac332d$export$af895a2490aecfd5), {
            key: item.id,
            item: item,
            showLabels: showLabels,
            showSpace: showSpace,
            excerptType: excerptType,
            limitLabelLinksToSpace: limitLabelLinksToSpace,
            isFirst: index === 0,
            RendererWrapper: RendererWrapper
        }))), hasNextPage && loadMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: loadMore,
        isLoading: isLoadingMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).loadMore))), loadMoreError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: loadMoreError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).errorSearch))))));
};
const $cd3bdf4cbbb70502$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $af06f72efa10cc57$export$a7357cdd1f0b0168).error);
const $cd3bdf4cbbb70502$export$539897642bf8eef = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $cd3bdf4cbbb70502$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd3bdf4cbbb70502$var$ContentByLabelMacroRendererComponent, props));
};
module.exports["ContentByLabelMacroRenderer"] = $cd3bdf4cbbb70502$export$539897642bf8eef;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});


//# sourceMappingURL=ContentByLabelMacroRenderer.5b49030a.js.map
